import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  geoChart: {
    '& .google-visualization-tooltip-item-list .google-visualization-tooltip-item:first-child': {
      display: 'none'
    }
  }
}))
